import { render, staticRenderFns } from "./SysQuestion.vue?vue&type=template&id=5bc79298&scoped=true"
import script from "./SysQuestion.vue?vue&type=script&lang=js"
export * from "./SysQuestion.vue?vue&type=script&lang=js"
import style0 from "./SysQuestion.vue?vue&type=style&index=0&id=5bc79298&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc79298",
  null
  
)

export default component.exports